import ArkLoader from '@src/js/common/ark-extensions';
import { IExtension } from '@tencent/ark-extensions/lib/types/src/extension-service/extension-service.interface';
import MegaSDK from '@tencent/mega-sdk';
import { EventEmitter } from '@tencent/mega-sdk-protocols';
import WcjsVideoPlayer from './component-config';
import { PlayerEventsManager } from './events-manager';

interface IInitPlayerOptions {
    id: string;
    src: string;
    events: EventEmitter;
}

interface IShowPlayerOptions {
    id: string;
    container: HTMLElement | null;
    getScale: () => number;
    getSrcRect?: () => Record<string, number>;
}

interface IHideOptions {
    id?: string;
}

interface IWcjsComponent extends IExtension{
    initPlayerStore(options: IInitPlayerOptions);
    getVideoImage(id: string, position?: number): Promise<Blob>;
    getCurrentImage(id: string): Promise<Blob>;
}

/**
 * 视频播放器采用唯一store统一管理所有player
 * getInstance兼容首次同时加载多个视频
 */
class WcjsVideoExtension {
    public static instance;
    public static getInstance() {
        if (!this.instance) {
            // eslint-disable-next-line no-async-promise-executor
            this.instance = new Promise(async (res) => {
                const extension = await ArkLoader.extensionService.getExtension<IWcjsComponent>(WcjsVideoPlayer.name);
                res(extension);
            });
        }
        return this.instance;
    }
}

// 调用方捕获异常并做降级处理
export async function showWcjsVideo(options: IInitPlayerOptions & IShowPlayerOptions): Promise<void> {
    const wcjsVideoExtension = await WcjsVideoExtension.getInstance();
    await wcjsVideoExtension.initPlayerStore({
        id: options.id,
        src: options.src,
        events: options.events,
    });
    wcjsVideoExtension.show({
        id: options.id,
        container: options.container,
        getScale: options.getScale,
        getSrcRect: options.getSrcRect,
    });
}

export async function hideWcjsVideo(options: IHideOptions): Promise<void> {
    if (!options.id) {
        return;
    }
    try {
        const wcjsVideoExtension = await WcjsVideoExtension.getInstance();
        wcjsVideoExtension.hide(options);
    } catch (e) {
        console.error(`${WcjsVideoPlayer.name} hideWcjsVideo catch error: ${e}`);
    }
}

export async function getWcjsVideoImage(url: string, position?: number): Promise<Blob> {
    const wcjsVideoExtension = await WcjsVideoExtension.getInstance();
    const id = `video-image-${url}`;
    const events = await PlayerEventsManager.createEvents(id);
    const src = await MegaSDK.Player.getPlayableSrcFromURI(url);
    await wcjsVideoExtension.initPlayerStore({
        id,
        src,
        events,
    });
    return wcjsVideoExtension.getVideoImage(id, position);
}

/**
 * @param id 跟视频播放器的 playerInstanceId保持一致  `${region}-${modelKey}`
 * @returns
 */
export async function getWcjsVideoCurrentImage(id: string): Promise<Blob> {
    const wcjsVideoExtension = await WcjsVideoExtension.getInstance();
    return wcjsVideoExtension.getCurrentImage(id);
}
